export default {
    imgprefix: 'https://chunyushu.oss-cn-beijing.aliyuncs.com/',
    uploadUrl: 'https://xyd.youline.cn/'
}
